import { ReactNode } from 'react';

import { CampaignTypeModal } from '@features/campaigns/list/components/MediaType/CampaignTypeModal/CampaignTypeModal.tsx';
import { MediaTypeTrigger } from '@features/campaigns/list/components/MediaType/Trigger/MediaTypeTrigger.tsx';
import { useCreatableMediaTypes } from '@features/campaigns/shared/hooks/useCreatableMediaTypes.ts';

interface CampaignTypeTriggerProps {
  linkStyle?: boolean;
  className?: string;
  fallbackView: ReactNode;
}

export function CampaignTypeTrigger({ linkStyle, className, fallbackView }: CampaignTypeTriggerProps) {
  const { isThematicCampaignCreationAvailable } = useCreatableMediaTypes();

  if (!isThematicCampaignCreationAvailable) {
    return fallbackView;
  }

  return <MediaTypeTrigger linkStyle={linkStyle} className={className} modal={CampaignTypeModal} />;
}
